// px strings on purpose: MUI's sx turns unitless width/height into "%" and unitless margin into theme.spacing()
const visuallyHiddenSx = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: 0,
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: 0,
};

export default visuallyHiddenSx;
